<template>
  <div class="p-4 px-lg-5 txt-grey-900 this-wraper">
    <div v-if="verifired && indication">
      <p class="fs-24 fw-700">
        {{ person && appUtils.getPersonInfoString(person) }}
      </p>
      <p class="fs-18 fw-700 txt-grey-900 mb-0">
        {{ indicationOrder && indicationOrder.name }}
      </p>
      <p class="fs-18 fw-700 txt-grey-900 mb-4">
        {{ indication && indication.name }}
      </p>

      <div class="row mb-3">
        <div class="col-md-6 col-lg-4">
          <div class="row">
            <div class="col-4"><p class="fs-16 mb-0">Ngày chỉ định</p></div>
            <div class="col-8">
              <p class="fs-16 fw-700 mb-0">
                {{
                  indicationOrder &&
                  indicationOrder.ind_date &&
                  formatIDate(indicationOrder.ind_date)
                }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4">
          <div class="row">
            <div class="col-4"><p class="fs-16 mb-0">Bác sĩ chỉ định</p></div>
            <div class="col-8">
              <p class="fs-16 fw-700 mb-0">
                {{
                  indicationOrder &&
                  indicationOrder.user &&
                  indicationOrder.user.name
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-6 col-lg-4">
          <div class="row">
            <div class="col-4"><p class="fs-16 mb-0">Nơi thực hiện</p></div>
            <div class="col-8">
              <p class="fs-16 fw-700 mb-0">
                {{
                  indication &&
                  indication.target_id &&
                  getDataDemo(indication.target_id)
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="">
        <p class="fs-18 fw-700">Kết quả</p>
        <div>
          <div
            v-for="f in docFiles"
            :key="f.id + 'file-file'"
            class="item-file"
            @click="downloadFile(f.file_name)"
          >
            <div class="mr-2">
              <svg
                width="23"
                height="24"
                viewBox="0 0 23 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_25089_126450)">
                  <path
                    d="M5.94255 0H13.4512L19.8073 7.09195V20.8779C19.8073 22.6023 18.5004 24 16.888 24H5.94255C4.33008 24 3.02319 22.6023 3.02319 20.8779V3.12212C3.02319 1.39769 4.33008 0 5.94255 0V0Z"
                    fill="#0263D1"
                  />
                  <path
                    opacity="0.302"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.4421 0V7.0337H19.8073L13.4421 0Z"
                    fill="white"
                  />
                  <path
                    d="M6.70264 16.6669V12.7881H9.17841V13.5494H7.57925V14.3449H9.0208V15.1082H7.57925V16.6669H6.70264Z"
                    fill="white"
                  />
                  <path
                    d="M10.4964 12.7881V16.6669H9.61982V12.7881H10.4964Z"
                    fill="white"
                  />
                  <path
                    d="M11.0468 16.6669V12.7881H11.9234V15.9055H13.4322V16.6669H11.0468Z"
                    fill="white"
                  />
                  <path
                    d="M13.886 16.6669V12.7881H16.4149V13.5494H14.7626V14.3449H16.2856V15.1082H14.7626V15.9055H16.4149V16.6669H13.886Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_25089_126450">
                    <rect
                      width="22.4413"
                      height="24"
                      fill="white"
                      transform="translate(0.19458)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div>
              <p class="fs-14 fw-500 mb-0 max-line-1">{{ f.name }}</p>
              <!-- <p class="fs-12 txt-grey-700 mb-0 max-line-1 text-right">
              09:30 21-22-2022
            </p> -->
            </div>
          </div>
        </div>
        <div>
          <div
            v-for="f in docLinks"
            :key="f.id + 'file-link'"
            class="item-link"
          >
            <div class="mr-2">
              <svg
                width="19"
                height="16"
                viewBox="0 0 19 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.1578 11.6999L6.82103 12.8466C6.4705 13.156 5.99509 13.3298 5.49937 13.3298C5.00364 13.3298 4.52823 13.156 4.1777 12.8466C3.82717 12.5371 3.63025 12.1175 3.63025 11.6799C3.63025 11.2423 3.82717 10.8227 4.1777 10.5132L7.60648 7.4799C7.94302 7.18186 8.39647 7.00942 8.87302 6.99825C9.34957 6.98708 9.81275 7.13804 10.1667 7.4199L10.2574 7.48657C10.4006 7.61033 10.5936 7.67881 10.794 7.67694C10.9945 7.67506 11.1858 7.60299 11.326 7.47657C11.4662 7.35015 11.5438 7.17974 11.5417 7.00283C11.5396 6.82592 11.4579 6.657 11.3147 6.53323C11.2721 6.48458 11.2267 6.43786 11.1788 6.39323C10.534 5.89811 9.70025 5.6378 8.84625 5.66503C7.99226 5.69226 7.18191 6.005 6.57936 6.5399L3.10526 9.57323C2.51494 10.1404 2.19567 10.887 2.21414 11.6571C2.23261 12.4271 2.58738 13.1611 3.20437 13.7057C3.82137 14.2504 4.65287 14.5635 5.52523 14.5799C6.39759 14.5962 7.24337 14.3143 7.88592 13.7932L9.19248 12.6666C9.32149 12.5423 9.3924 12.3796 9.39096 12.2111C9.38952 12.0425 9.31583 11.8807 9.18471 11.7582C9.05359 11.6357 8.87478 11.5616 8.68425 11.5508C8.49373 11.54 8.30563 11.5932 8.1578 11.6999ZM16.2313 2.20657C15.596 1.64924 14.7367 1.33643 13.841 1.33643C12.9453 1.33643 12.086 1.64924 11.4506 2.20657L10.1441 3.33323C10.0151 3.45747 9.94415 3.62022 9.9456 3.78874C9.94704 3.95727 10.0207 4.11906 10.1518 4.24156C10.283 4.36406 10.4618 4.43818 10.6523 4.449C10.8428 4.45983 11.0309 4.40655 11.1788 4.2999L12.4853 3.15323C12.8358 2.84381 13.3113 2.66998 13.807 2.66998C14.3027 2.66998 14.7781 2.84381 15.1286 3.15323C15.4792 3.46265 15.6761 3.88232 15.6761 4.3199C15.6761 4.75749 15.4792 5.17715 15.1286 5.48657L11.6999 8.5199C11.3633 8.81794 10.9099 8.99038 10.4333 9.00155C9.95677 9.01272 9.4936 8.86176 9.13961 8.5799L9.04898 8.51323C8.90577 8.38947 8.71272 8.32099 8.51231 8.32286C8.31189 8.32474 8.12053 8.39681 7.98032 8.52323C7.84011 8.64965 7.76253 8.82006 7.76466 8.99697C7.76678 9.17388 7.84843 9.3428 7.99165 9.46657C8.04651 9.51609 8.1045 9.56283 8.16536 9.60657C8.81084 10.1002 9.64428 10.3595 10.4978 10.3323C11.3512 10.3051 12.1613 9.99336 12.7648 9.4599L16.2011 6.42657C16.8365 5.86928 17.1963 5.11272 17.202 4.32207C17.2076 3.53141 16.8587 2.77089 16.2313 2.20657Z"
                  fill="#6E7883"
                />
              </svg>
            </div>
            <div>
              <p class="fs-14 fw-500 mb-0 max-line-1 txt-pri">
                {{ f.url }}
              </p>
            </div>
          </div>
        </div>
        <div class="my-4">
          <p class="fs-18 fw-700 mb-1">Mô tả</p>
          <div v-if="indication.examination_results && indication.examination_results.conclusion" v-html="indication.examination_results.conclusion.description"></div>
        </div>
        <div>
          <p class="fs-18 fw-700">Kết luận</p>
          <p class="fs-14 fw-700 whitespace-pre-wrap" v-if="indication.examination_results && indication.examination_results.conclusion">
            {{ indication.examination_results.conclusion.conclusion }}
          </p>
          <p class="fs-14 mb-1 fw-700 whitespace-pre-wrap" v-for="c in conclusions" :key="c.id + 'conclusion'">
            {{ c.conclusion }}
          </p>
        </div>

      </div>
    </div>
    <div
      v-else
      class="
        flex flex-column
        justify-content-center
        align-items-center
        otp-wraper
      "
    >
      <OtpInput
        ref="otpInput"
        input-classes="otp-input text-center"
        separator="&nbsp;"
        :num-inputs="4"
        :should-auto-focus="true"
        :is-input-num="true"
        @on-change="handleOnChange"
        @on-complete="handleOnComplete"
      ></OtpInput>
      <button
        @click="getOTP(true)"
        class="btn w-50 fs-18 "
        :disabled="timeout > 0 || loading || sendingOtp"
      >
        <span v-if="sendingOtp">
          Hệ thống đang gửi mã OTP, vui lòng chờ trong giây lát
        </span>
        <span v-else>
          Gửi lại mã sau <span v-if="timeout"><span class="fw-500">{{ timeout }} </span>giây</span>
        </span>
        <span
          class="spinner-border ml-1"
          role="status"
          v-if="sendingOtp || loading"
          style="width: 1rem; height: 1rem;"
        >
          <span class="sr-only">Loading...</span>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import OtpInput from '@bachdgvn/vue-otp-input'
import appUtils from '../../utils/appUtils'
import moment from 'moment'
import dataMemo from './dataMemo'
import downloadS3 from '../../utils/downloadS3'
export default {
  name: 'IndicationResult',
  components: { OtpInput },
  data () {
    return {
      indication: {},
      verifired: false,
      otp: '',
      timeout: 0,
      interval_timeout: null,
      appUtils,
      target: dataMemo,
      sendingOtp: false,
      loading: false
    }
  },
  mounted () {
    if (this.interval_timeout) clearInterval(this.interval_timeout)
    if (this.$route.params.id) this.sendOtpIndicationResult()
  },
  computed: {
    person () {
      let person = null
      if (this.indication?.indication_order?.health_record?.person) person = this.indication?.indication_order?.health_record?.person
      if (this.indication?.indication_order?.medical_record?.person) person = this.indication?.indication_order?.medical_record?.person
      return person
    },
    indicationOrder () {
      return this.indication?.indication_order
    },
    docFiles () {
      return this.indication?.all_files?.filter((f) => f.type === 1)
    },
    docLinks () {
      return this.indication?.all_files?.filter((f) => f.type === 2)
    },
    conclusions () {
      return this.indication?.conclusions
    }
  },
  methods: {
    async sendOtpIndicationResult () {
      this.sendingOtp = true
      await this.$rf.getRequest('GuestRequest').sendOtpIndicationResult(this.$route.params.id).then(() => {
        this.setIntervalTimeOut()
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.sendingOtp = false
      })
    },
    async otpVerify (otp) {
      if (!otp || !this.$route.params.id) return
      this.loading = true
      await await this.$rf.getRequest('GuestRequest').getIndicationResult(this.$route.params.id, { otp }).then((r) => {
        this.indication = r.data
        this.verifired = true
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.loading = false
      })
    },
    async downloadFile (name) {
      if (!name) return
      downloadS3.downloadFileRC(name)
    },
    setIntervalTimeOut () {
      const self = this
      self.timeout = 60
      clearInterval(self.interval_timeout)
      self.interval_timeout = setInterval(() => {
        if (self.timeout > 0) {
          self.timeout--
        } else {
          clearInterval(self.interval_timeout)
        }
      }, 1000)
    },
    handleOnComplete (value) {
      // console.log('OTP completed: ', value)
      this.otpVerify(value)
    },
    handleOnChange (value) {
      // console.log('OTP changed: ', value)
    },
    handleClearInput () {
      this.$refs.otpInput.clearInput()
    },
    formatIDate (d) {
      return moment(d).format('HH:mm DD/MM/YYYY')
    },
    getDataDemo (id) {
      return id ? this.target[id - 1].name : ''
    }
  }
}
</script>

<style scoped>
.item-file {
  display: flex;
  max-width: 100%;
  align-items: center;
  /* border: 1px solid rgb(216, 216, 216);
  background-color: rgb(232, 234, 235); */
  cursor: pointer;
  margin-bottom: 16px;
}
.item-link {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 16px;
}
.this-wraper {
  min-height: calc(100vh - 80px);
}
.otp-wraper {
  padding-left: 16px;
  padding-right: 16px;
  height: calc(100vh - 300px);
}
</style>
